<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="接口账号">
                  <el-input style="width: 177px" v-model="queryForm.userName"></el-input>
              </el-form-item>
<!--              <el-form-item label="用户状态">-->
<!--                  <el-select style="width: 177px" v-model="queryForm.userStatus" placeholder="请选择" clearable size="small">-->
<!--                      <el-option label="不冻结" :value="0"></el-option>-->
<!--                      <el-option label="冻结" :value="1"></el-option>-->
<!--                  </el-select>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getApiUserList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addApiUser"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editApiUser(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteApiUser(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshApiUserList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="apiUserList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userName"
        label="账号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userPass"
        label="密码"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="apiPass"
        label="API密码"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userMobile"
        label="手机号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userStatus"
        label="用户状态"
        width="180"
      >
          <template slot-scope="scope">
            {{scope.row.userStatus==0?'正常':'冻结'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="smsCount"
        label="接口短信条量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="adsmsCount"
        label="广告短信条量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="mailCount"
        label="邮件剩余条数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="regTimeFormatter"
        label="注册时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkApiUser(scop.row.userId)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editApiUser(scop.row.userId)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteApiUser(scop.row.userId)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="apiUserStates[apiUserState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="apiUser"
          ref="apiUserForm"
          :rules="rules"
          label-width="110px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="接口账号"
            prop="userName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiUser.userName"
              :disabled="apiUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="接口密码"
            prop="userPass"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiUser.userPass"
              :disabled="apiUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="API密码"
            prop="apiPass"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiUser.apiPass"
              :disabled="apiUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="手机号"
            prop="userMobile"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiUser.userMobile"
              :disabled="apiUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户状态"
            prop="userStatus"
          >
              <el-select style="width: 177px" v-model="apiUser.userStatus" :disabled="apiUserState == 'check'" placeholder="请选择" clearable size="small">
                  <el-option label="正常" :value="0"></el-option>
                  <el-option label="冻结" :value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="接口短信条量"
            prop="smsCount"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiUser.smsCount"
              :disabled="apiUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="广告短信条量"
            prop="adsmsCount"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiUser.adsmsCount"
              :disabled="apiUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="邮件剩余条数"
            prop="mailCount"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiUser.mailCount"
              :disabled="apiUserState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="apiUserState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetApiUserList();
                    this.getApiUserList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetApiUserList();
                    this.getApiUserList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userName: '', //账号
                     userPass: '', //密码
                     apiPass: '', //api密码
                     userMobile: '', //用户固定电话
                     userStatus: '', //用户状态：用来冻结账号 0:不冻结；1:冻结  默认0
                     smsCount: '', //接口短信剩余条数
                     adsmsCount: '', //广告短信剩余条数
                     mailCount: '', //邮件剩余条数
                     regTime: '', //注册时间
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                apiUserState: 'add',
                apiUserStates: {
                    add: '新建接口账号',
                    check: '查看接口账号',
                    edit: '修改接口账号'
                },

                multipleSelection: [],
                apiUserList: [],
                apiUser: {
                    userId: '', //
                    userName: '', //账号
                    userPass: '', //密码
                    apiPass: '', //api密码
                    userMobile: '', //用户固定电话
                    userStatus: 0, //用户状态：用来冻结账号 0:不冻结；1:冻结  默认0
                    smsCount: '', //接口短信剩余条数
                    adsmsCount: '', //广告短信剩余条数
                    mailCount: '', //邮件剩余条数
                    regTime: '', //注册时间
                },
                btnLoading: false,

                rules: {
                    userName: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
                    userPass: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
                    apiPass: [{ required: true, message: 'api密码不能为空', trigger: 'blur' }],
                    userMobile: [{ required: true, message: '用户固定电话不能为空', trigger: 'blur' }],
                    userStatus: [{ required: true, message: '用户状态不能为空', trigger: 'blur' }],
                    smsCount: [{ required: true, message: '接口短信剩余条数不能为空', trigger: 'blur' }],
                    adsmsCount: [{ required: true, message: '广告短信剩余条数不能为空', trigger: 'blur' }],
                    mailCount: [{ required: true, message: '邮件剩余条数不能为空', trigger: 'blur' }],
                    regTime: [{ required: true, message: '注册时间不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getApiUserList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetApiUserList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.apiUserList = [];
            },
            resetDialog() {
                this.apiUserState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userName: '', //账号
                      userPass: '', //密码
                      apiPass: '', //api密码
                      userMobile: '', //用户固定电话
                      userStatus: '', //用户状态：用来冻结账号 0:不冻结；1:冻结  默认0
                      smsCount: '', //接口短信剩余条数
                      adsmsCount: '', //广告短信剩余条数
                      mailCount: '', //邮件剩余条数
                      regTime: '', //注册时间
                };
                this.getApiUserList();
            },
            closeDialog() {
                this.showDialog = false
                this.apiUser = {
                      userName: '', //账号
                      userPass: '', //密码
                      apiPass: '', //api密码
                      userMobile: '', //用户固定电话
                      userStatus: 0, //用户状态：用来冻结账号 0:不冻结；1:冻结  默认0
                      smsCount: '', //接口短信剩余条数
                      adsmsCount: '', //广告短信剩余条数
                      mailCount: '', //邮件剩余条数
                      regTime: '', //注册时间
                };
            },
            submitForm() {
                if (this.apiUserState == 'add') {
                    this.$refs.apiUserForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/api/user/add`,{ ...this.apiUser }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetApiUserList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.apiUserState == 'edit') {
                    this.$refs.apiUserForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/api/user/edit`,{ ...this.apiUser }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetApiUserList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addApiUser() {
                this.showDialog = true;
                this.apiUserState = 'add';
            },
            checkApiUser(apiUserId) {
                console.log(apiUserId);
                this.currentApiUserId = apiUserId;

                this.getApiUserById();
                this.showDialog = true;
                this.apiUserState = 'check';
            },
            editApiUser(apiUserId) {
                console.log('apiUser', apiUserId);
                if (apiUserId) {
                    this.currentApiUserId = apiUserId;
                    this.getApiUserById();
                } else {
                    this.apiUser = { ...this.apiUser, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.apiUserState = 'edit';
            },
            deleteApiUser(apiUserId) {
                let ids = '';
                if (apiUserId) {
                    ids = apiUserId;
                } else {
                    ids = this.multipleSelection.map((apiUser) => apiUser.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/api/user/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetApiUserList();
                                this.getApiUserList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshApiUserList() {
                this.resetApiUserList();
                this.getApiUserList();
            },
            getApiUserList(query = {}) {
                this.loading = true;
                get(`/api/user/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.apiUserList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getApiUserById() {
                get(`/api/user/get`,{ id: this.currentApiUserId }).then((res) =>{
                    if(res.success){
                      this.apiUser = { ...this.apiUser, ...res.apiUser };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportApiUserList() {
                //this.btnLoading = true;
                exprotExcel(`/api/user/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/api/user/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/api/user/importData`,formData);
              this.refreshApiUserList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getApiUserList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getApiUserList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>